import { Injectable } from "@angular/core";
import * as ExcelJS from "exceljs";
import * as FileSaver from "file-saver";

const EXCEL_TYPE =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";

@Injectable({ providedIn: "root" })
export class ExcelService {
    public exportAsExcelFile(json: any[]): void {
        this.exportAsExcelFileMultiSheet([{ name: "data1", data: json }]);
    }

    public exportAsExcelFileMultiSheet(
        sheets: { name: string; data: any[] }[],
    ): void {
        const workbook = new ExcelJS.Workbook();

        for (const sheet of sheets) {
            const worksheet = workbook.addWorksheet(
                sheet.name.substring(0, 31),
            );
            if (sheet.data.length > 0) {
                worksheet.columns = Object.keys(sheet.data[0]).map((key) => ({
                    header: key,
                    key: key,
                }));
                worksheet.addRows(sheet.data);
            }
        }

        workbook.xlsx.writeBuffer().then((buffer) => {
            this.saveAsExcelFile(buffer);
        });
    }

    private saveAsExcelFile(buffer: any): void {
        const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });

        FileSaver.saveAs(data, new Date().getTime() + EXCEL_EXTENSION);
    }
}
